// eslint-disable-next-line no-restricted-imports
import { Tooltip, TooltipProps } from '@material-ui/core';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';

export interface WbTooltipProps extends Omit<TooltipProps, 'open'> {
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
}

export const WbTooltip = (props: WbTooltipProps) => {
  const {
    title,
    children,
    open: openProp,
    setOpen: setOpenProp,
    ...rest
  } = props;
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = openProp !== undefined && setOpenProp !== undefined;
  const open = isControlled ? openProp : internalOpen;
  const setOpen = isControlled ? setOpenProp : setInternalOpen;

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handler = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && open) {
        handleClose();
      }
    },
    [open, handleClose],
  );

  useEffect(() => {
    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('keydown', handler);
    };
  }, [handler]);

  return (
    <Tooltip
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      title={title}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};
